import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabservicemumbai() {



    const cardData = {

keyword: "Sedan Cab Service Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Sedan Cab Service Mumbai for airport transfers, local travel, corporate commuting, family trips, sightseeing tours, and outstation journeys. Our fleet includes well-maintained sedan cars such as Swift Dzire, Honda Amaze, Hyundai Xcent, and similar vehicles that provide excellent comfort, fuel efficiency, and smooth travel. With professional chauffeurs, 24x7 availability, transparent pricing, doorstep pickup and drop, and flexible booking options, we ensure a safe, comfortable, and hassle-free travel experience across Mumbai and beyond.",

topPlaces: [
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves are among India's most treasured UNESCO World Heritage Sites, featuring ancient Buddhist rock-cut caves and remarkable artwork dating back centuries. Travelers often book sedan cabs from Mumbai for a comfortable heritage journey to explore this world-famous archaeological destination."
    },
    {
        title: "Wilson Hills",
        description:
            "Wilson Hills is a beautiful hill station in Gujarat known for its cool climate, panoramic viewpoints, lush greenery, and peaceful atmosphere. A sedan cab offers a smooth and economical travel experience for families and couples visiting this scenic retreat."
    },
    {
        title: "Ganpatipule",
        description:
            "Ganpatipule is a renowned Konkan destination famous for its pristine beach and ancient Ganpati temple. Sedan cab services are popular for this coastal route, providing comfortable travel for pilgrims and vacationers alike."
    },
    {
        title: "Ujjain",
        description:
            "Ujjain is one of India's holiest cities and home to the sacred Mahakaleshwar Jyotirlinga. Devotees frequently choose sedan cab services from Mumbai for a convenient and comfortable pilgrimage experience."
    },
    {
        title: "Bhandardara",
        description:
            "Bhandardara is a serene hill destination known for Arthur Lake, Randha Falls, and stunning mountain landscapes. Sedan cabs are ideal for small families and couples planning relaxing weekend trips from Mumbai."
    },
    {
        title: "Diu",
        description:
            "Diu is a charming coastal destination known for its beaches, Portuguese architecture, forts, and laid-back atmosphere. Travelers prefer sedan cabs for comfortable long-distance journeys to this peaceful seaside getaway."
    },
    {
        title: "Tuljapur",
        description:
            "Tuljapur is one of Maharashtra's most important pilgrimage destinations, famous for the revered Tulja Bhavani Temple. Sedan cab services provide a convenient travel option for devotees visiting throughout the year."
    },
    {
        title: "Amboli",
        description:
            "Amboli is a picturesque hill station surrounded by forests, waterfalls, and mist-covered valleys. It is a favorite destination for monsoon travel, and sedan cabs ensure a comfortable road trip through scenic routes."
    },
    {
        title: "Velas Beach",
        description:
            "Velas is known for its annual turtle festival and untouched natural beauty. This peaceful coastal village attracts travelers looking for a quiet beach escape away from crowded tourist destinations."
    },
    {
        title: "Omkareshwar",
        description:
            "Omkareshwar is one of the twelve Jyotirlingas and a major spiritual destination located on the banks of the Narmada River. Sedan cab services are frequently booked for religious tours and comfortable long-distance travel from Mumbai."
    }
],



services: [
{
name: "Sedan Cab Service Mumbai",
description: "Mumbai Airport Cab offers Sedan Cab Service Mumbai for travellers looking for comfortable, economical, and reliable transportation across Mumbai and outstation destinations. Our fleet includes well-maintained sedan vehicles such as Swift Dzire, Toyota Etios, Honda Amaze, Hyundai Xcent, and other premium options suitable for airport transfers, corporate travel, family trips, local sightseeing, business meetings, railway station transfers, hotel transfers, and long-distance journeys. With professional chauffeurs, clean air-conditioned vehicles, transparent pricing, doorstep pickup and drop service, flexible booking options, and 24x7 customer support, we ensure a smooth, safe, and hassle-free travel experience. Whether you need transportation for a few hours, a full day, or an outstation tour, our sedan cab service delivers comfort, affordability, and dependable service throughout every journey."
},
{
name: "Mumbai Sedan Cab Service",
description: "Mumbai Airport Cab provides Mumbai Sedan Cab Service with chauffeur-driven vehicles designed for comfortable city travel, airport transportation, business meetings, family outings, holiday tours, and outstation journeys. Our sedan fleet offers comfortable seating, ample luggage space, fuel-efficient travel, and smooth ride quality for both urban roads and highways. We focus on punctual pickups, professional drivers, transparent pricing, convenient booking procedures, and excellent customer support to ensure every passenger enjoys reliable, safe, and stress-free transportation across Mumbai and nearby destinations."
},
{
name: "Sedan Taxi Mumbai",
description: "Book Sedan Taxi Mumbai with Mumbai Airport Cab and enjoy affordable, comfortable, and dependable transportation for local travel, airport pickups, corporate rides, family functions, shopping trips, sightseeing tours, and intercity journeys. Our clean and well-maintained sedan vehicles provide air-conditioned comfort, professional chauffeur service, spacious interiors, and smooth travel experiences. We prioritize safety, punctuality, customer satisfaction, and vehicle quality while delivering convenient transportation solutions for individuals, families, and business travellers throughout Mumbai."
},
{
name: "Mumbai Sedan Car Rental",
description: "Mumbai Airport Cab offers Mumbai Sedan Car Rental service for customers seeking flexible and affordable transportation for personal travel, corporate requirements, airport transfers, holiday trips, and business visits. Our sedan vehicles are maintained to high standards and driven by experienced chauffeurs who ensure safe and comfortable travel. With transparent rates, multiple rental options, easy booking, and dedicated customer support, we provide convenient transportation solutions tailored to every travel requirement."
},
{
name: "Dzire Sedan Cab Mumbai",
description: "Dzire Sedan Cab Mumbai service by Mumbai Airport Cab provides comfortable and economical transportation using well-maintained Maruti Swift Dzire vehicles. Ideal for airport transfers, local city rides, business meetings, family travel, railway station pickups, and outstation trips, our Dzire cabs offer excellent comfort, fuel efficiency, and luggage capacity. Professional chauffeurs, flexible travel schedules, and reliable service ensure a pleasant journey for every passenger."
},
{
name: "Etios Sedan Cab Mumbai",
description: "Mumbai Airport Cab provides Etios Sedan Cab Mumbai service with spacious Toyota Etios vehicles suitable for family travel, airport transfers, corporate transportation, sightseeing tours, and long-distance journeys. Our clean and comfortable sedans are operated by trained chauffeurs who focus on safety, punctuality, and customer convenience. We offer affordable pricing, flexible booking options, and dependable service for all travel needs across Mumbai and beyond."
},
{
name: "Affordable Sedan Cab Mumbai",
description: "Affordable Sedan Cab Mumbai service is designed for customers seeking cost-effective transportation without compromising on comfort, safety, or service quality. Mumbai Airport Cab offers budget-friendly sedan vehicles for airport transfers, daily commuting, family trips, business travel, and outstation journeys. With professional drivers, transparent pricing, well-maintained vehicles, and reliable customer support, we provide exceptional value and dependable transportation solutions."
},
{
name: "Mumbai Local Sedan Taxi",
description: "Mumbai Local Sedan Taxi service by Mumbai Airport Cab provides convenient transportation for daily commuting, shopping trips, office travel, local sightseeing, personal errands, and city-wide travel requirements. Our sedan vehicles offer comfortable seating, air-conditioned interiors, experienced chauffeurs, and affordable rates. We ensure timely pickups, safe travel, and a pleasant journey experience throughout Mumbai and surrounding areas."
},
{
name: "Mumbai Outstation Sedan Cab",
description: "Book Mumbai Outstation Sedan Cab with Mumbai Airport Cab for comfortable travel to destinations such as Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Aurangabad, Goa, and more. Our sedan vehicles are ideal for long-distance travel, offering comfortable seating, luggage space, air-conditioned comfort, and experienced highway drivers. We provide flexible itineraries, transparent pricing, and dependable transportation for family vacations, business trips, and holiday tours."
},
{
name: "Sedan Car Hire Mumbai",
description: "Sedan Car Hire Mumbai service offers flexible chauffeur-driven transportation for airport transfers, local travel, corporate journeys, family outings, sightseeing tours, and outstation trips. Mumbai Airport Cab provides clean and comfortable sedan vehicles supported by professional drivers, easy booking options, and dedicated customer assistance. Our goal is to deliver safe, reliable, and convenient travel experiences for every passenger."
},
{
name: "Mumbai Sedan Airport Cab",
description: "Mumbai Airport Cab offers Mumbai Sedan Airport Cab service with timely pickup and drop facilities for domestic and international airport terminals. Our chauffeurs monitor flight schedules, assist with luggage, and ensure punctual transportation in comfortable air-conditioned sedan vehicles. Whether travelling for business or leisure, passengers enjoy reliable service, smooth travel, and stress-free airport transfers."
},
{
name: "Sedan One Way Cab Mumbai",
description: "Sedan One Way Cab Mumbai service provides affordable transportation for passengers who require travel without return charges. Mumbai Airport Cab offers convenient one-way transfers for airport travel, intercity journeys, business trips, family visits, and holiday travel. With transparent pricing, professional chauffeurs, comfortable sedan vehicles, and flexible pickup locations, we ensure cost-effective and hassle-free transportation."
},
{
name: "Sedan Round Trip Mumbai",
description: "Mumbai Airport Cab provides Sedan Round Trip Mumbai service for return travel requirements including family vacations, business visits, pilgrimage tours, sightseeing journeys, and weekend getaways. Our comfortable sedan vehicles, experienced drivers, and flexible scheduling options ensure reliable transportation throughout the trip. We focus on safety, punctuality, travel comfort, and customer satisfaction from departure to return."
},
{
name: "Sedan Business Travel Mumbai",
description: "Sedan Business Travel Mumbai service is designed for professionals, executives, and corporate travellers requiring reliable transportation for meetings, conferences, client visits, airport transfers, and business events. Mumbai Airport Cab provides comfortable sedan vehicles, professional chauffeurs, punctual service, and executive travel convenience. We help business travellers maintain productivity and professionalism while travelling throughout Mumbai and nearby cities."
},
{
name: "Sedan Family Cab Mumbai",
description: "Sedan Family Cab Mumbai service offers comfortable transportation for families travelling for vacations, airport transfers, sightseeing tours, shopping trips, social functions, and weekend outings. Mumbai Airport Cab provides clean and spacious sedan vehicles with professional drivers, flexible schedules, and affordable pricing. We ensure safe, comfortable, and enjoyable journeys for families of all sizes."
},
{
name: "Sedan Daily Hire Mumbai",
description: "Mumbai Airport Cab offers Sedan Daily Hire Mumbai service for customers requiring dedicated transportation throughout the day for business activities, personal errands, city travel, meetings, sightseeing, and family functions. Our chauffeur-driven sedan vehicles provide flexibility, convenience, comfort, and dependable service with transparent pricing and professional customer support."
},
{
name: "Sedan Chauffeur Service Mumbai",
description: "Sedan Chauffeur Service Mumbai combines comfortable sedan vehicles with highly trained professional drivers who prioritize safety, punctuality, and customer satisfaction. Mumbai Airport Cab provides chauffeur-driven transportation for airport transfers, corporate travel, family journeys, city tours, and outstation trips. Our commitment to professionalism and service quality ensures a premium travel experience at affordable rates."
},
{
name: "Sedan City Ride Mumbai",
description: "Book Sedan City Ride Mumbai with Mumbai Airport Cab for convenient local transportation across business districts, residential areas, tourist attractions, shopping centres, railway stations, and airports. Our air-conditioned sedan vehicles provide smooth rides, comfortable seating, and professional chauffeur service. We deliver safe, efficient, and reliable city transportation for daily travel needs."
},
{
name: "Sedan Long Distance Mumbai",
description: "Sedan Long Distance Mumbai service offers dependable transportation for extended road trips, interstate travel, corporate journeys, pilgrimage tours, and holiday vacations. Mumbai Airport Cab provides comfortable sedan vehicles with experienced drivers, flexible itineraries, luggage space, and affordable pricing. We ensure passengers enjoy safe, relaxing, and comfortable travel over long distances."
},
{
name: "Premium Sedan Cab Mumbai",
description: "Premium Sedan Cab Mumbai service delivers enhanced comfort, professional chauffeur service, and superior travel convenience for airport transfers, executive transportation, family travel, business meetings, and outstation journeys. Mumbai Airport Cab provides clean and well-maintained premium sedan vehicles with modern amenities, spacious interiors, and reliable service standards. We focus on delivering exceptional comfort, safety, and customer satisfaction for every journey."
}
],

tableData: [
["Sedan Cab Service Mumbai","Mumbai Sedan Cab Service"],
["Sedan Taxi Mumbai","Mumbai Sedan Car Rental"],
["Dzire Sedan Cab Mumbai","Etios Sedan Cab Mumbai"],
["Affordable Sedan Cab Mumbai","Mumbai Local Sedan Taxi"],
["Mumbai Outstation Sedan Cab","Sedan Car Hire Mumbai"],
["Mumbai Sedan Airport Cab","Sedan One Way Cab Mumbai"],
["Sedan Round Trip Mumbai","Sedan Business Travel Mumbai"],
["Sedan Family Cab Mumbai","Sedan Daily Hire Mumbai"],
["Sedan Chauffeur Service Mumbai","Sedan City Ride Mumbai"],
["Sedan Long Distance Mumbai","Premium Sedan Cab Mumbai"]
],


whychoose: [
    {
        WhyChooseheading: "Reliable Sedan Cab Service in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Sedan Cab Services in Mumbai for airport transfers, local travel, corporate transportation, sightseeing tours, and outstation journeys."
    },
    {
        WhyChooseheading: "Comfortable Travel for Every Occasion",
        WhyChoosedescription: "Sedan cars offer excellent comfort, spacious seating, smooth rides, and a pleasant travel experience for both short and long-distance journeys."
    },
    {
        WhyChooseheading: "Ideal for Business and Corporate Travel",
        WhyChoosedescription: "Professionals, executives, and corporate travelers frequently choose sedan cabs for meetings, conferences, airport transfers, and official travel requirements."
    },
    {
        WhyChooseheading: "Multiple Sedan Vehicle Options",
        WhyChoosedescription: "Customers can choose from Swift Dzire, Honda Amaze, Hyundai Aura, Maruti Suzuki Dzire, and other premium sedan vehicles according to their travel needs."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Trips",
        WhyChoosedescription: "Our sedan cab services are available for travel within Mumbai as well as destinations such as Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, and Ahmedabad."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide seamless airport transportation with comfortable sedan vehicles for domestic and international travelers."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, punctual service, route expertise, and a comfortable journey for every passenger."
    },
    {
        WhyChooseheading: "Affordable and Convenient Transportation",
        WhyChoosedescription: "Sedan cabs offer a perfect balance of affordability, comfort, and convenience for individuals, families, and business travelers."
    }
]
};

const faqData = [
    {
        question: "What is included in Sedan Cab Service Mumbai?",
        answer: "Sedan Cab Service includes airport transfers, local city travel, outstation trips, corporate transportation, sightseeing tours, and customized travel solutions."
    },
    {
        question: "Which sedan cars are available for booking?",
        answer: "Customers can choose Swift Dzire, Honda Amaze, Hyundai Aura, Maruti Suzuki Dzire, and other sedan vehicles depending on availability."
    },
    {
        question: "Can I book a sedan cab for Mumbai Airport transfers?",
        answer: "Yes, sedan cabs are available for airport pickup and drop services at Mumbai Airport."
    },
    {
        question: "Are sedan cabs available for outstation travel?",
        answer: "Yes, customers can book sedan cabs for Pune, Nashik, Shirdi, Goa, Lonavala, Mahabaleshwar, Ahmedabad, and many other destinations."
    },
    {
        question: "How many passengers can travel in a sedan cab?",
        answer: "Most sedan vehicles comfortably accommodate up to 4 passengers along with luggage."
    },
    {
        question: "Can corporate travelers book sedan cabs regularly?",
        answer: "Yes, many companies and professionals use sedan cabs for business meetings, airport transfers, and daily corporate transportation."
    },
    {
        question: "Do you provide chauffeur-driven sedan cabs?",
        answer: "Yes, all sedan cab bookings include experienced and professional drivers."
    },
    {
        question: "Can I book a sedan cab for full-day local travel?",
        answer: "Yes, customers can hire sedan cabs for full-day city travel, meetings, shopping trips, and sightseeing."
    },
    {
        question: "Is advance booking recommended for sedan cab services?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning."
    },
    {
        question: "How can I book a Sedan Cab Service in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ashish Bhandari",
        feedback:
            "The sedan cab was clean, comfortable, and perfect for my airport transfer. The driver arrived on time and the journey was smooth throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Nidhi Agarwal",
        feedback:
            "We booked a sedan cab for an outstation trip and were extremely satisfied with the service. The vehicle was well-maintained and the overall travel experience was excellent.",
        rating: 5
    }
];









































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Sedan Cab Service Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/sedan-cab-service-mumbai.jpg",
"description": "Book sedan cab service in Mumbai for comfortable, affordable, and reliable travel. Mumbai Airport Cabs offers well-maintained sedan cars like Dzire and Etios for local rides, airport transfers, business travel, and outstation journeys with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/sedan-cab-service-mumbai"
}
};






    return (
        <div>



<Helmet>
  <title>Sedan Cab Service Mumbai | Affordable Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book sedan cab service in Mumbai for local travel, airport transfers, business trips, and outstation rides. Comfortable Dzire and Etios sedan cars with professional drivers at affordable rates."
/>

<meta
 name="keywords"
 content="sedan cab service mumbai, mumbai sedan cab service, sedan taxi mumbai, mumbai sedan car rental, dzire sedan cab mumbai, etios sedan cab mumbai, affordable sedan cab mumbai, mumbai local sedan taxi, mumbai outstation sedan cab, sedan car hire mumbai, mumbai sedan airport cab, sedan one way cab mumbai, sedan round trip mumbai, sedan business travel mumbai, sedan family cab mumbai, sedan daily hire mumbai, sedan chauffeur service mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sedancabservicemumbai;